import $ from 'jquery'
import validator from 'utils/validator'
import _ from 'lodash'
import 'jquery-mask-plugin'

# LEAD FORM
_validate = (field, el)->
  if validator.validate(field, $(el).val())
    $(".alert-error.#{field}").each ->
      parent = $(this).parent()
      if parent.find('.error').length > 0
        $(this).hide()
    $(el).removeClass('error')
    return true
  else
    $(el).addClass('error')
    $(".alert-error.#{field}").each ->
      parent = $(this).parent()
      if parent.find('.error').length > 0
        $(this).show()
    return false

$('.validate-phone').mask('(00) 000000009')

$('.validate-email').on 'blur', ->
  _validate('email', this)

$('.validate-email').on 'keyup',
  _.debounce(() -> _validate('email', '.validate-email')
  500)

$('.email-field-js').on 'blur', ->
  _validate('email', this)

$('.validate-phone').on 'blur', ->
  _validate('phone', this)

$('.lead-capture form, #lead-form-news, .lead-form form, .js-lead-form').on 'submit', (e)->

  $emailField = $(this).find('.validate-email')
  $phoneField = $(this).find('.validate-phone')

  if $emailField.length > 0 && !_validate('email', $emailField)
    e.preventDefault()
  if $phoneField.length > 0 && !_validate('phone', $phoneField)
    e.preventDefault()

  source = $('body').data('controller')
  source = 'competitors' if source == 'static_page'
  source = 'new_university_page' if $('#page').hasClass('new-look')
  _require ['metrics'], ->
    trackable.eventTracker.track Metrics.Events.RegisteredLead, { source: source }
  return true
